import { Alert, Button, Form, Input, Space } from 'antd'
import { LoginRequest } from '../../api/auth'
import api from '../../api'
import { useState } from 'react';
import { ErrorMessage } from '../../shared/components/ErrorMessage';
import { Link } from '../../shared/components/Link';
import getStore from '../store';
import { useLocation, useSearchParams } from 'react-router-dom';
import { getDefaultBrokerInfo } from '../../trade-preference/utils';
import selectedBrokerRepo from '../../brokers/repos/selected-broker-repo';

export const LoginForm = () => {

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const [searchParams] = useSearchParams();
  const emailVerified = !!(searchParams.get('emailVerified'));

  const location = useLocation();
  const signupSuccess = location?.state?.signupSuccess || false;

  const login = async (data : LoginRequest) => {
    try {

      setSubmitting(true);

      const tokens = await api.auth.login(data);

      const store = getStore()
      await store.setTokens(tokens);
      
      const user = await api.auth.me()
      await store.setUser(user);

      const defaultBrokerInfo = getDefaultBrokerInfo(user?.trade_preference);
      if (defaultBrokerInfo)  {
        await selectedBrokerRepo.setBroker(defaultBrokerInfo);
      }

    } catch (e) {
      setError(e)
    } finally {
      setSubmitting(false);
    }
  }

  return <div>
    <Form<LoginRequest>
      layout='vertical'
      onFinish={login}
    >
      <ErrorMessage error={error}/>
      {
        (signupSuccess || emailVerified) && <Alert
          showIcon
          style={{ marginTop: 16, marginBottom: 16 }}
          type='success'
          message={<span>Your Account Is Created. <br/> Login to continue</span>}
        />
      }
      <Form.Item
        label="Email"
        name="email"
        rules={[
          { required: true, message: 'email is required' },
          { type: 'email', message: 'must be a valid email' }
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Password"
        name="password"
        rules={[
          { required: true, message: 'password is required' },
        ]}
      >
        <Input.Password />
      </Form.Item>

      <Form.Item>
        <Button
          style={{ width: '100%' }}
          loading={submitting}
          disabled={submitting}
          type="primary"
          size='large'
          htmlType="submit"
        >
          Login
        </Button>
      </Form.Item>

      <Form.Item>
        <div style={{ width: '100%', textAlign: 'center' }}>
          <Space direction='vertical'>
            {/* @ts-ignore */}
            <Link to="/auth/reset-password">
              Forgot Password?
            </Link>
            {/* @ts-ignore */}
            <Link to="/auth/sign-up">
              Dont Have An Account? Sign Up
            </Link>
          </Space>
        </div>
      </Form.Item>
    </Form>
  </div>
}